<template>
  <div>
    <e-dialog
      dialog-title="合同附件"
      :center-dialog-visible="contractUploadVisible"
      popup-width="600px"
      :show-btn="showBtn"
      :show-close-btn="showCloseBtn"
      @resetPopupData="handleClose"
      @submitPopupData="handleConfirm"
    >
      <tableList
        class="margin-t20"
        row-key="companyId"
        :index-show="true"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template #attachmentMust="{ scope: { row } }">
          <span v-if="row.attachmentMust === '1'" style="color: #f0250f">必传</span>
          <span v-else>非必传</span>
        </template>
        <template #uploadFileName="{ scope: { row, $index } }">
          <div style="padding: 4px 0">
            <el-upload
                    v-if="row?.contractAttachList?.length < 5 && handleFlag === 'upload'"
                    ref="uploadFile"
                    :action="uploadUrl"
                    :headers="headers"
                    :show-file-list="false"
                    :auto-upload="true"
                    :on-success="getFileInfo"
                    :before-upload="handleBeforeUpload"
            >
              <eui-btn
                icon="eicon-upload"
                icon-position="left"
                type="secondary"
                @click="handleUpload($index)"
                >上传附件
              </eui-btn>
            </el-upload>
            <div
              v-for="(item, index) in row.contractAttachList"
              :key="index"
              class="flex-sc"
              :class="{
                'margin-t10': row?.contractAttachList?.length > 1 && handleFlag === 'upload',
              }"
            >
              <eui-icon
                icon="eicon-r-l-wenjian"
                font-size="16px"
                style="margin-right: 4px"
              ></eui-icon>
              <div @click="viewFile(item.url)">
                <e-tooltip-over
                  :line="1"
                  :tooltip-style="{
                    width: '130px',
                    color: '#0064c8',
                    height: '16px',
                    cursor: 'pointer',
                  }"
                  :content="item.name"
                >
                </e-tooltip-over>
              </div>

              <div @click="handleDelFile($index, index)">
                <eui-icon
                  v-if="handleFlag === 'upload'"
                  icon="eicon-r-l-guanbi"
                  font-size="14px"
                ></eui-icon>
              </div>
            </div>
          </div>
        </template>
      </tableList>
    </e-dialog>
  </div>
</template>

<script>
import api from '../../api/order';
import productApi from '@/modules/projectA/api/product';
import eDialog from './e-dialog.vue';
import tableList from './e-table-list';
import eTooltipOver from './e-tooltip-over.vue';
import { epecToken } from '../../utils/globalData';

export default {
  name: 'ContractUpload',
  components: {
    eDialog,
    tableList,
    eTooltipOver,
  },
  props: {
    contractUploadVisible: Boolean,
    handleFlag: String,
    viewContractAttachData: Array,
    categoryCode: String,
  },
  data() {
    return {
      showCloseBtn: false,
      showBtn: true,
      fileIndex: null,
      uploadUrl: api.orderAttachUpload,
      headers: epecToken,
      queryData: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      // type:2 合同，type :3 发票
      tableData: [
      ],
      tableLabel: [
        {
          label: '交付资料清单',
          param: 'attachmentName',
          align: 'left',
          headerText: 'left',
        },
        {
          label: '是否必传',
          param: 'attachmentMust',
          align: 'center',
          slot: 'attachmentMust',
          width: '120',
        },
        {
          label: '文件名称',
          param: '',
          align: 'left',
          headerText: 'left',
          slot: 'uploadFileName',
        },
      ],
    };
  },
  mounted() {
    console.log(this.handleFlag, this.viewContractAttachData, 'ffffff');
    if (this.handleFlag === 'view') {
      this.showCloseBtn = true;
      this.showBtn = false;
    }
    if (this.viewContractAttachData.length > 0) {
      this.tableData = this.viewContractAttachData;
    }

    this.ruleQueryList();
  },
  methods: {
    //attachmentType:采购合同：0  、 附件：1    共同清单接口
    async ruleQueryList() {
      let params = {
        sceneType: 1,//场景类型 固定传1
        categoryCode: this.categoryCode,
        attachmentType: 0,
      }
      const res = await productApi.ruleQueryList(params);
      if (res.code === '200') {
        let contractList = res.data.filter((item) => item.attachmentType === '0');

        this.tableData = contractList.length > 0 ? contractList[0].reviewRuleList : [];

        this.tableData.forEach((item) => {
          this.$set(item, 'contractAttachList', []);
          this.viewContractAttachData.forEach((viewData) => {
            if (item.id === viewData.categoryReviewAttachmentId) {
              item.contractAttachList.push({
                name: viewData.name,
                url: viewData.url,
                categoryReviewAttachmentId: viewData.categoryReviewAttachmentId,
                tag: item.attachmentName,
                type: 2,
              });
            }
          });
        });

        // 封装其他类型得文件数据
        const otherAttachList = this.viewContractAttachData.filter(
                (item) => !item.categoryReviewAttachmentId
        );

        otherAttachList.forEach(item => {
          item.type = 2;
          item.tag = '其他';
        })

        this.tableData.push({
          attachmentName: '其他',
          attachmentMust: 0,
          contractAttachList: otherAttachList || [],
        });

        console.log(this.tableData, 'this.tableDatarrr');
      }
    },
    viewFile(url) {
      window.open(url);
    },
    handleDelFile(tableIndex, fileIndex) {
      this.tableData[tableIndex].contractAttachList.splice(fileIndex, 1);
    },
    handleUpload(index) {
      this.fileIndex = index;
    },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 200) {
        this.$message({ message: '附件不能超过200M。', type: 'warning' });
        return false;
      }
      return true;
    },
    getFileInfo(res, file) {
      if (this.tableData[this.fileIndex].contractAttachList.length === 5) {
        this.$message.warning({ message: '只能上传五个附件。' });
        return false;
      }
      // type:2 合同，type :3 发票
      if (res.success) {
        const params = {
          url: file.response.data.url,
          name: file.name,
          categoryReviewAttachmentId: this.tableData[this.fileIndex].id || '', // 空是其他
          type: 2,
          tag: this.tableData[this.fileIndex].attachmentName || '',
        };
        this.tableData[this.fileIndex].contractAttachList.push(params);
      }
    },
    handleConfirm() {

      const attachmentMustArr = this.tableData.filter((item) => Number(item.attachmentMust) === 1);
      const noAttachArr = attachmentMustArr.filter((item) => item.contractAttachList.length === 0);
      if (noAttachArr.length > 0) {
        this.$message.warning('请先上传“必传”附件后再点击“确定”按钮。');
        return false;
      }

      this.$emit('dealContractAttachData', this.tableData);
      this.handleClose();
    },
    handleClose() {
      this.$emit('update:contractUploadVisible', false);
    },
  },
};
</script>

<style scoped></style>
